import { ImagePicture } from 'approot/shared/images/images.style';
import {
  ImageViewWrapper,
  ImageContainer,
  ImageFillWrapper,
} from './image.style';
import { useImageDimensionEffect } from 'approot/shared/images/images.hooks';
import type { GetActivitiesSectionsQuery } from '../../lesson-builder.graphql.generated';
import { computePaddingTop } from '../shared/component-height/component-dimension.utils';
import { getLargestImage } from '../shared/logic/get-largest-image';
import {
  ComponentHeightWrapper,
  ComponentInnerWrapper,
} from '../shared/component-height/component-dimensions.style';
import { ComponentCaption } from '../shared/component-caption/component-caption';
import { ComponentImage } from '../component.constants';
import type { Pluck } from 'lib/gql/pluck';

const ImagePicturePreview = ({
  imageUrl,
  imageDimensions,
}: {
  imageUrl: string;
  imageDimensions?: { width: number; height: number };
}) => {
  return (
    <ImagePicture $imageHasLoaded>
      <img
        src={imageUrl}
        alt=""
        style={
          imageDimensions
            ? {
                width: imageDimensions.width,
                height: imageDimensions.height,
              }
            : undefined
        }
      />
    </ImagePicture>
  );
};

export const ImageViewFit = ({
  imageUrls,
}: {
  imageUrls: Pluck<
    Extract<
      Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
      { __typename: 'ActivitiesImageComponent' }
    >,
    'properties.imageUrls'
  >[];
}) => {
  const { imageDimensions, setContainerElement } = useImageDimensionEffect({
    imageUrl: getLargestImage(imageUrls),
  });
  return (
    <ImageViewWrapper ref={setContainerElement}>
      <ImagePicturePreview
        imageDimensions={imageDimensions}
        imageUrl={imageUrls[0]?.urls?.[0]?.url || ''}
      />
    </ImageViewWrapper>
  );
};

export const ImageViewFill = ({
  imageUrls,
}: {
  imageUrls: Pluck<
    Extract<
      Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
      { __typename: 'ActivitiesImageComponent' }
    >,
    'properties.imageUrls'
  >[];
}) => {
  return (
    <ImageFillWrapper>
      <ImagePicturePreview imageUrl={imageUrls[0]?.urls?.[0]?.url || ''} />
    </ImageFillWrapper>
  );
};

const ImageStaticPreview = ({
  id,
  properties: {
    showCaptionOnLesson,
    imageUrls,
    dimensionData,
    cropData,
    caption,
  },
}: Omit<ComponentImage, '__typename'>) => {
  const isFit = !cropData;

  return (
    <ComponentHeightWrapper
      style={{
        paddingTop: `${computePaddingTop(dimensionData)}%`,
      }}
    >
      <ComponentInnerWrapper>
        <ImageContainer $fullBorderRadius={!showCaptionOnLesson}>
          {isFit ? (
            <ImageViewFit imageUrls={imageUrls || []} />
          ) : (
            <ImageViewFill imageUrls={imageUrls || []} />
          )}
        </ImageContainer>
        <ComponentCaption
          id={id}
          caption={caption}
          showCaption={showCaptionOnLesson}
        />
      </ComponentInnerWrapper>
    </ComponentHeightWrapper>
  );
};

export default ImageStaticPreview;
